import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStore = defineStore("app", () => {
  const hasNotSavedChanges = ref(false);
  const textForConfirm = ref("");

  const setNotSavedChanges = (text?: string) => {
    hasNotSavedChanges.value = true;
    textForConfirm.value = text || "";
  };

  const resetNotSavedChanges = () => {
    hasNotSavedChanges.value = false;
    textForConfirm.value = "";
  };

  return {
    hasNotSavedChanges,
    textForConfirm,
    setNotSavedChanges,
    resetNotSavedChanges,
  };
});
